<div
  class="item cursor-pointer bg-gray-50 rounded-xl ca-shadow flex items-center mb-5"
  >
  <div class="icon">
    <mat-icon>link</mat-icon>
  </div>
  <div class="meta">
    <div class="supertitle">{{ description }}</div>
    <span class="text-caPrimaryAction block url">{{ url }}</span>
    <span class="note" *hasRole="DASHBOARD_ROLES">
      @if (roles) {
        <span>
          {{
          "sharedWith"
          | translate
          : {
          roles: roles | translateroles : "plural" | formattedlist
        }
        }}
      </span>
    } @else {
      {{
      "sharedWith"
      | translate
      : {
      roles:
      NULL_ROLES_VISIBILITY
      | translateroles : "plural"
      | formattedlist
    }
    }}
  }
</span>
</div>

<button
  *hasRole="DASHBOARD_ROLES"
  mat-icon-button
  [matMenuTriggerFor]="moreMenu"
  (click)="$event.stopPropagation()"
  >
  <mat-icon>more_vert</mat-icon>
</button>
</div>

<mat-menu #moreMenu="matMenu">
  <button [disabled]="loading" (click)="viewHistory.emit(url)" mat-menu-item>
    <mat-icon item-start>history_outlined</mat-icon>
    View History
  </button>
  <button [disabled]="loading" (click)="updateRoles()" mat-menu-item>
    <mat-icon item-start>visibility</mat-icon>
    {{ "whoShouldSeeThis" | translate }}
  </button>
  <button [disabled]="loading" (click)="removeLink.emit(url)" mat-menu-item>
    <mat-icon item-start>close</mat-icon>
    Remove
  </button>
</mat-menu>
